<template>
  <form @submit.prevent="submitSearch" class="mb-0">
    <div class="relative">
      <input
        type="text"
        v-model="input"
        placeholder="Enter a domain name, e.g. numexample.com"
        class="w-full p-4"
        ref="input"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="none"
        spellcheck="false"
      />
      <div
        class="absolute right-0 top-0 bottom-0 flex items-center px-2 text-gray-700 cursor-pointer"
        @click="clearInput"
        v-if="input !== ''"
      >
        <ion-icon name="close-circle-sharp"></ion-icon>
      </div>
    </div>
  </form>
</template>

<script>
import { mapMutations } from "vuex";

import eventHub from "@/eventHub";

import router from "@/router";

import { CLEAR_TEMP_NUM_RESULTS } from "@/store/types/mutations";

export default {
  name: "NumSearch",
  props: {
    searchValue: String,
  },
  data() {
    return {
      input: "",
    };
  },
  watch: {
    searchValue: {
      // parse query string value to the input
      handler(newVal) {
        this.input = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations([CLEAR_TEMP_NUM_RESULTS]),
    clearInput() {
      this.input = "";
      this.$nextTick(() => this.$refs.input.focus());
    },
    submitSearch() {
      const trimmedInput = this.input.trim();
      this.$refs.input.blur();
      this.CLEAR_TEMP_NUM_RESULTS(); // don't use local cache, query DNS again
      window.scrollTo(0, 0);
      this.$nextTick(() => router.push({ query: { s: trimmedInput } }));
      if (this.searchValue === trimmedInput) {
        // if the existing search matches the new search, then this won't
        // update the query string, so it won't trigger a new search, so we
        // manually handle this case here
        eventHub.$emit("force-search", trimmedInput);
      }
    },
  },
};
</script>
